module.exports = __webpack_public_path__ + "img/new-bt-pay.48ebf23e.png";